// LOOSE ENDS MIXIN FOR ENTIRE FUNNEL
export const GeneralMixin = {
   methods: {

      /**
       * Get our Vue `OrderSummary` component.
       *
       * @return {object}
       */
      getSummaryComponent() {
         return this.$refs['summary'];
      },

      /**
       * Use this default/generic message for handling AJAX responses that don't have any error
       * messages.
       *
       * @param cartShortNumber
       * @return {*}
       */
      getDefaultErrorMessage(cartShortNumber) {
         if(cartShortNumber) {
            return this.translations.responses.updateKnownCart.replace('{#}', cartShortNumber);
         }

         return this.translations.responses.updateCart
      },

      /**
       * Take any errors sent back from posting to a controller and re-format them to
       * be more usable in our Vue error modal.
       *
       * Yii returns errors as an array of arrays because a field could have multiple errors
       * with it. So here, we're filtering them out into just one array.
       *
       * @param data {array}
       * @returns {Array}
       */
      getYiiErrors(data) {
         if (typeof data === 'string') {
            data = [[data]];
         }

         let errors = [];
         for (let key in data) {
            let array = data[key];
            for (let subkey in array) {
               errors.push(array[subkey]);
            }
         }
         return errors;
      }
   },
}